import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5557 20.3147C15.9112 21.4135 13.9778 22 12 22C10.6868 22 9.38642 21.7413 8.17316 21.2388C6.9599 20.7362 5.85751 19.9997 4.92893 19.0711C4.00034 18.1425 3.26375 17.0401 2.7612 15.8268C2.25865 14.6136 2 13.3132 2 12C2 10.0222 2.58649 8.08879 3.6853 6.4443C4.78412 4.79981 6.3459 3.51808 8.17316 2.7612C10.0004 2.00433 12.0111 1.80629 13.9509 2.19215C15.8907 2.578 17.6725 3.53041 19.0711 4.92893C20.4696 6.32746 21.422 8.10929 21.8078 10.0491C22.1937 11.9889 21.9957 13.9996 21.2388 15.8268C20.4819 17.6541 19.2002 19.2159 17.5557 20.3147ZM11.1464 8.14645C11.0527 8.24021 11 8.36739 11 8.5L11 11.5C11 11.6326 11.0527 11.7598 11.1464 11.8536C11.2402 11.9473 11.3674 12 11.5 12L12.5 12C12.6326 12 12.7598 11.9473 12.8535 11.8536C12.9473 11.7598 13 11.6326 13 11.5L13 8.5C13 8.36739 12.9473 8.24021 12.8536 8.14645C12.7598 8.05268 12.6326 8 12.5 8L11.5 8C11.3674 8 11.2402 8.05268 11.1464 8.14645ZM11.1464 14.1464C11.0527 14.2402 11 14.3674 11 14.5L11 15.5C11 15.6326 11.0527 15.7598 11.1464 15.8536C11.2402 15.9473 11.3674 16 11.5 16L12.5 16C12.6326 16 12.7598 15.9473 12.8535 15.8536C12.9473 15.7598 13 15.6326 13 15.5L13 14.5C13 14.3674 12.9473 14.2402 12.8535 14.1464C12.7598 14.0527 12.6326 14 12.5 14L11.5 14C11.3674 14 11.2402 14.0527 11.1464 14.1464Z"
      fill="#9B001A"
    />
  </svg>
);
const SvgNoteColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgNoteColored;
